/**
 * Convert various value types to boolean
 * @param {*} value - The value to convert
 * @returns {boolean} - The converted boolean value
 */
export const convertToBoolean = (value) => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
        return value.toLowerCase() === 'yes' || value.toLowerCase() === 'true';
    }
    return false;
};
